import { Injectable, signal } from '@angular/core';

export interface SplashState {
  status: 'idle' | 'splash' | 'menuClosed' | 'connectionError' | 'disabled';
  imageUrl?: string;
  languages?: string[];
}

@Injectable({
  providedIn: 'root'
})

export class SplashScreenService {
  splashState = signal<SplashState>({ status: 'disabled' });

  updateSplashStatus(status: SplashState['status'], imageUrl?: string, languages?: string[]): void {
    switch (status) {
      case 'splash':
        this.splashState.set({ status: 'splash', imageUrl });
        break;
      case 'menuClosed':
        this.splashState.set({ status: 'menuClosed', imageUrl, languages: languages || ['en', 'ar', 'ru']  });
        break;
      case 'connectionError':
        this.splashState.set({ status: 'connectionError' });
        break;
      case 'idle':
        this.splashState.set({ status: 'idle' });
        break;
      case 'disabled':
      default:
        this.splashState.set({ status: 'disabled' });
        break;
    }
  }
}
